import Page from 'front/pages/Page/Page';
import Urls from 'django_js_front/reverse.js';
import * as _ from 'underscore';

import TopBar from 'front/components/Common/TopBar/TopBar';
import IllustrationItem from 'front/components/IllustrationComponents/IllustrationItem/IllustrationItem';
import IllustrationItemTemplate
from 'front/components/IllustrationComponents/IllustrationItem/IllustrationItemFrontendRendering.jinja';

import {VIEWPORT_EVENTS} from '../../constants/Constants';
import axios from 'axios';
import './Illustrations.less';

import * as Template from './Illustrations.jinja';

const Selectors = {
    el: '.Illustrations',
    onMoreButton: '.Illustrations-more',
    topBarFilters: '.TopBar-filters',
    tobBarFilterItem: '.TopBar-filtersItem'
};

const BindFunctions = [
    'onMoreLinkClick',
    'onLoad'
];


export default class Illustrations extends Page {
    events() {
        return {
            [`${VIEWPORT_EVENTS.click} ${Selectors.onMoreButton}`]: this.onMoreLinkClick
        };
    }

    constructor(options = {}) {
        options.el = '.Illustrations';
        options.VIEWS_TO_REGISTER = {
            'top-bar': {selector: '.TopBar', viewConstructor: TopBar},
            'illustration-item': {selector: '.IllustrationItem', viewConstructor: IllustrationItem}
        };
        options.template = Template;
        super(options);
        _.bindAll(this, BindFunctions);

        this.$more = this.$('.Illustrations-more');
        this.$moreContent = this.$('.Illustrations-wrapper');
        this.count = 60;
    }

    onLoad(data) {
        if (data) {
            for (let i = 0; i <= data.length && data[i] !== undefined; i++) {
                var $moreItems = $(IllustrationItemTemplate.render({
                    illustration: data[i],
                    language: window.app.settings.language
                }));

                this.$moreContent.append($moreItems);
            }

            this.count += data.length;
            this.observer.observe();
            this.onResize();

            if (this.$moreContent.data('length') <= this.count) {
                this.$more.addClass('hidden');
            }
        }
    }

    onMoreLinkClick() {
        axios.get(Urls['front:api:illustrations'](), {
            params: {
                loaded: this.count
            }
        }).then(response => {
            this.$more.addClass('isHide');
            this.onLoad(response?.data);
        });

        setTimeout(() => {
            this.$more.outerHeight();
            this.$more.show(200);
        }, 500);
    }
}
